import React from "react";

export function PageHeader({ title, subtitle, action, testId }) {
  return (
    <div className="flex items-start justify-between mb-8" data-testid={testId}>
      <div>
        <h1 className="font-heading text-3xl md:text-4xl tracking-tight text-foreground font-medium">{title}</h1>
        {subtitle && (
          <p className="text-sm text-foreground/60 mt-2">{subtitle}</p>
        )}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ title = "Henüz veri bulunmamaktadır", hint, action, testId }) {
  return (
    <div className="border border-dashed border-border rounded-md py-16 text-center" data-testid={testId}>
      <div className="font-heading text-lg text-foreground/70">{title}</div>
      {hint && <div className="text-sm text-foreground/50 mt-2">{hint}</div>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function Section({ title, right, children }) {
  return (
    <section className="mb-10">
      <div className="flex items-end justify-between mb-4">
        <h2 className="font-heading text-lg text-foreground/90 font-medium">{title}</h2>
        {right}
      </div>
      {children}
    </section>
  );
}
